import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import PageContainer from "../../components/PageContainer";
import Info from "./components/Info";
import FormData from "./components/FormData";
import { fetchProfile } from "../../actions/profile";

const Profile = () => {
  const [fullName, setFullName] = useState("");

  const dispatch = useDispatch();
  const {
    loading,
    data: profileData = {
      username: "",
    },
  } = useSelector((state) => state.profile);
  useEffect(() => {
    fetchProfileData();
    // eslint-disable-next-line
  }, []);

  const fetchProfileData = () => dispatch(fetchProfile());

  useEffect(() => {
    if (
      !loading &&
      profileData != null &&
      profileData.hasOwnProperty("extraInfo") &&
      profileData.extraInfo != null
    ) {
      setFullName(
        profileData.extraInfo.hasOwnProperty("firstName")
          ? `${profileData.extraInfo.firstName} `
          : "" + profileData.hasOwnProperty("extraInfo") &&
            profileData.extraInfo.hasOwnProperty("lastName")
          ? profileData.extraInfo.lastName
          : ""
      );
    }
  }, [loading, profileData]);

  return (
    <PageContainer
      headerProps={{
        right: "",
        content: "پروفایل",
        link: "/menu",
      }}
      classNames={"profile-wrapper "}
      loading={loading}
    >
      <div className="profile-page">
        <Info
          avatarUrl={
            profileData &&
            profileData.hasOwnProperty("extraInfo") &&
            profileData.extraInfo &&
            profileData.extraInfo.hasOwnProperty("avatarImageUrl")
              ? profileData.extraInfo?.avatarImageUrl
              : 5
          }
          id={profileData.id}
          name={fullName}
          userName={profileData.mobile}
          profile={profileData}
          fetchProfile={fetchProfileData}
        />
        <FormData profile={profileData} fetchProfile={fetchProfileData} />
      </div>
    </PageContainer>
  );
};

export default Profile;
